import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = ["d"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b('', { deposit: _ctx.isDeposit }))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.b('direction')),
      "aria-hidden": "true"
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("path", {
          d: _ctx.isDeposit ? 'M12 5v14M6 13l6 6 6-6' : 'M12 19V5M6 11l6-6 6 6'
        }, null, 8, _hoisted_2)
      ]))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('content'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('title'))
      }, _toDisplayString(_ctx.$t(_ctx.isDeposit ? "Пополнение" : "Вывод")) + " · " + _toDisplayString(_ctx.currencyName), 3),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('date'))
      }, _toDisplayString(_ctx.row.created_at), 3)
    ], 2),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.b('amount', { deposit: _ctx.isDeposit }))
    }, _toDisplayString(_ctx.isDeposit ? "+" : "-") + _toDisplayString(_ctx.displayedAmount), 3),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.b('status', { [_ctx.statusTone]: true }))
    }, [
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.statusLabel)), 1)
    ], 2)
  ], 2))
}